import React, { useEffect, useState } from "react"; // Add useState
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { PeriodProvider } from 'components/PeriodContext';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import WinRateGraph from "components/WinRateGraph";
import ProfitFactorGraph from "components/ProfitFactorGraph";
import EquityGraph from "components/EquityGraph";
import AvgHoldingTimeChart from "components/AvgHoldingTimeChart";
import RiskOverTimeChart from "components/RiskOverTimeChart";
import RRRatioAnalysisChart from "components/RRRatioAnalysisChart";
import TradeConfidenceChart from "components/TradeConfidenceChart";
import TimeBasedPerformanceChart from "components/TimeBasedPerformanceChart";
import TagPerformanceChart from "components/TagPerformanceChart";
import TradingSessionChart from "components/TradingSessionChart";

const Charts = ({ userID, tradeAccountID, trades, setSelectedAccountID, tradeAccounts }) => { // Add props
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is signed in with UID:", user.uid);
      } else {
        console.log("User is signed out");
      }
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar
        tradeAccounts={tradeAccounts}
        selectedAccountID={tradeAccountID}
        setSelectedAccountID={setSelectedAccountID}
      />
      <MDBox py={3}>
        <PeriodProvider>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <WinRateGraph userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <ProfitFactorGraph userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDBox mb={3}>
                <EquityGraph userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <AvgHoldingTimeChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <RiskOverTimeChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <RRRatioAnalysisChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <TradeConfidenceChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <TimeBasedPerformanceChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <TagPerformanceChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <TradingSessionChart userID={userID} tradeAccountID={tradeAccountID} />
              </MDBox>
            </Grid>
          </Grid>
        </PeriodProvider>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

Charts.propTypes = {
  userID: PropTypes.string.isRequired,
  tradeAccountID: PropTypes.string,
  trades: PropTypes.array,
  setSelectedAccountID: PropTypes.func,
  tradeAccounts: PropTypes.array,
};

export default Charts;